import React from 'react';
import { RouterProps } from '../shared/types/route.type';
import { AppRoutes } from './routeConstants/appRoutes';
import CreateProductFlow from '../views/CreateProductFlow/RawMaterial';
import CreateProductTransportaion from '../views/CreateProductFlow/Transportation';
import CreateProductProcessingFacility from '../views/CreateProductFlow/ProcessingFacility';
import ProductDistribution from '../views/CreateProductFlow/ProductDistribution';
import ProductsDashboard from '../views/ProductsDashboard';
import ProductOverview from '../views/CreateProductFlow/ProductOverview';
import PrivateRoute from '../shared/components/PrivateRoute';
import ProductDashboardCharts from '../views/Products/ProductDashboardCharts';
import ChildProducts from '../views/ChildProducts';
import DownloadMap from '../views/CreateProductFlow/ProductOverview/DownloadMap';
import CreateProduct from '../views/CreateProduct';
import { Outlet } from 'react-router-dom';

export const productRoutes: RouterProps[] = [
  {
    path: AppRoutes.CREATE_PRODUCT_MODAL,
    element: (
      <PrivateRoute>
        <CreateProduct />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.PRODUCT_DASHBOARD,
    element: (
      <PrivateRoute>
        <ProductDashboardCharts />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.PRODUCT_OVERVIEW,
    element: (
      <PrivateRoute>
        <ProductOverview />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CHILD_PRODUCTS,
    element: (
      <PrivateRoute>
        <ChildProducts />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.DOWNLOAD_MAP,
    element: (
      <PrivateRoute>
        <DownloadMap />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CREATE_PRODUCT,
    element: (
      <PrivateRoute>
        <Outlet />
      </PrivateRoute>
    ),
    children: [
      {
        path: AppRoutes.CREATE_PRODUCT_RAW_MATERIAL,
        element: <CreateProductFlow />,
      },
      {
        path: AppRoutes.CREATE_PRODUCT_RAW_MATERIAL_TRANSPORTATION,
        element: <CreateProductTransportaion />,
      },
      {
        path: AppRoutes.CREATE_PRODUCT_PROCESSING_FACILITY,
        element: <CreateProductProcessingFacility />,
      },
      {
        path: AppRoutes.CREATE_PRODUCT_PRODUCT_DISTRIBUTION,
        element: <ProductDistribution />,
      },
    ],
  },
  {
    path: AppRoutes.PRODUCT,
    element: (
      <PrivateRoute>
        <Outlet />
      </PrivateRoute>
    ),
    children: [
      {
        path: '',
        element: <ProductsDashboard />,
      },
      {
        path: AppRoutes.IN_REVIEW,
        element: <ProductsDashboard />,
      },
      {
        path: AppRoutes.APPROVED,
        element: <ProductsDashboard />,
      },
      {
        path: AppRoutes.DRAFT,
        element: <ProductsDashboard />,
      },
      {
        path: AppRoutes.DECLINED,
        element: <ProductsDashboard />,
      },
      {
        path: AppRoutes.BRANDS,
        element: <ProductsDashboard />,
      },
    ],
  }
]; 